var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-spinner',{attrs:{"small":"","type":"grow"}}),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text)+" ...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }